
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 384.008 384.008"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M320 .004c-29.752 0-54.76 20.44-61.896 48H125.896c-7.136-27.56-32.144-48-61.896-48-35.288 0-64 28.712-64 64 0 29.752 20.44 54.76 48 61.896v132.216c-27.56 7.128-48 32.136-48 61.888 0 35.288 28.712 64 64 64 29.752 0 54.76-20.44 61.896-48H200c8.832 0 16-7.168 16-16s-7.168-16-16-16h-74.104c-5.808-22.432-23.464-40.088-45.896-45.896V125.9c22.432-5.808 40.088-23.464 45.896-45.896h132.216c7.136 27.56 32.136 48 61.896 48 35.288 0 64-28.712 64-64s-28.72-64-64.008-64zm-224 320c0 17.648-14.352 32-32 32s-32-14.352-32-32 14.352-32 32-32 32 14.352 32 32zm-32-224c-17.648 0-32-14.352-32-32s14.352-32 32-32 32 14.352 32 32-14.352 32-32 32zm256 0c-17.648 0-32-14.352-32-32s14.352-32 32-32 32 14.352 32 32-14.352 32-32 32zM256 304.004h-8c-8.832 0-16 7.168-16 16s7.168 16 16 16h8c8.832 0 16-7.168 16-16s-7.168-16-16-16zM312 304.004h-8c-8.832 0-16 7.168-16 16s7.168 16 16 16h8c8.832 0 16-7.168 16-16s-7.168-16-16-16zM368 304.004h-8c-8.832 0-16 7.168-16 16s7.168 16 16 16h8c8.832 0 16-7.168 16-16s-7.168-16-16-16z"}})])
          )
        }
      }
    